import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import OptionedProductSectionForm from 'ui-shared/Forms/OptionedProductSectionForm'

const FoodSectionCreate: React.FC = () => {
  return (
    <SectionWrapper title={'resources.foodsections.createSection'}>
      <Create>
        <OptionedProductSectionForm entity="foods" />
      </Create>
    </SectionWrapper>
  )
}

export default FoodSectionCreate
